<template>
    <div class="menu-button"
		 :class="{'active': isActive, 'menu-button--small': props.small}"
		 @click="isActive = !isActive">
        <span v-for="i in 4" :key="i" :style="{backgroundColor: props.color}"/>
    </div>
</template>

<script setup lang="ts">

const props = defineProps<{
	small?: boolean,
	color?: string,
}>();

const isActive = defineModel();
</script>

<style>
/* ==========================================================================
   Mixins
   ========================================================================== */
/*********************
  Inputs
**********************/
.menu-button {
  cursor: pointer;
  position: relative;
  width: 24px;
  height: 20px;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -ms-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -webkit-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
}
.menu-button span {
  height: 2.4px;
}
.menu-button span:nth-child(2), .menu-button span:nth-child(3) {
  top: 8px;
}
.menu-button span:nth-child(4) {
  top: 16px;
}
.menu-button.active span:nth-child(1) {
  top: 8px;
}
.menu-button.active span:nth-child(4) {
  top: 8px;
}
.menu-button span {
  display: block;
  position: absolute;
  width: 100%;
  background: #5e6b6b;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -ms-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -webkit-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
}
.menu-button span:nth-child(1) {
  top: 0;
}
.menu-button.active span:nth-child(1) {
  width: 0;
  left: 50%;
}
.menu-button.active span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.menu-button.active span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.menu-button.active span:nth-child(4) {
  width: 0;
  left: 50%;
}
.menu-button--small {
  width: 14.4px;
  height: 12px;
}
.menu-button--small span {
  height: 2.4px;
}
.menu-button--small span:nth-child(2), .menu-button--small span:nth-child(3) {
  top: 4.8px;
}
.menu-button--small span:nth-child(4) {
  top: 9.6px;
}
.menu-button--small.active span:nth-child(1) {
  top: 4.8px;
}
.menu-button--small.active span:nth-child(4) {
  top: 4.8px;
}
</style>